<template>
    <v-card :class="[{'pa-0 grey lighten-4 mt-2': $vuetify.breakpoint.smAndDown}, 'pb-3']"
            :flat="$vuetify.breakpoint.smAndDown">
        <v-card-title :class="[{'px-4 pt-2 subtitle-1 font-weight-bold': $vuetify.breakpoint.smAndDown},
                                {'pa-5': $vuetify.breakpoint.mdAndUp}]">
            <span  :class="[{'mb-2': $vuetify.breakpoint.smAndDown}]">Gast-Spielberichte zur Bestätigung</span>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                          label="in Liste suchen" filled dense class="d-inline-block"
                          single-line hide-details style="max-width: 350px" >
                <template v-slot:append>
                    <v-btn icon small class="pb-1">
                        <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="spiele" :search="search" disable-pagination
                      item-key="name" sort-by="name" hide-default-footer mobile-breakpoint="1"
                      :class="[{'mx-0': $vuetify.breakpoint.smAndDown},
                               {'mx-4': $vuetify.breakpoint.mdAndUp},
                               'elevation-1 mb-2']">
            <template v-slot:item.liga="{ item }">
                <v-hover v-slot="{ hover }">
                    <span @click="quickSearch(item.liga)" style="cursor: pointer"
                          :class="{ 'primary--text': hover }">{{item.liga}}</span>
                </v-hover>
            </template>
            <template v-slot:item.rundeGroup="{ item }">
                <v-hover v-slot="{ hover }">
                    <span @click="quickSearch(item.rundeGroup)" style="cursor: pointer"
                          :class="{ 'primary--text': hover }">{{item.rundeGroup}}</span>
                </v-hover>
            </template>
            <template v-slot:item.heimTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="heim" @filtered="quickSearch"
                                          :class="[{ 'primary--text': hover },
                                                   { 'font-weight-bold': item.winner==='heim' }]">
                    </tab-teams-with-icons>

                </v-hover>
            </template>
            <template v-slot:item.gastTeam="{ item }">
                <v-hover v-slot="{ hover }">
                    <tab-teams-with-icons :item="item" type="gast" @filtered="quickSearch"
                                          :class="[{ 'primary--text': hover },
                                                   { 'font-weight-bold': item.winner==='gast' }]">
                    </tab-teams-with-icons>
                </v-hover>
            </template>
            <template v-slot:item.ergebnis="{ item }">
                <div class="text-no-wrap">{{item.ergebnis}}</div>
            </template>
            <template v-slot:item.schnitt="{ item }">
                <div class="text-no-wrap">{{item.schnitt}}</div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div style="white-space: nowrap">
                    <tool-tip text="Spielbericht ansehen und bestätigen">
                        <v-btn class="d-inline-block" icon
                               @click="openConfirm(item, 'confirmErgebnis')">
                            <v-icon>mdi-check</v-icon></v-btn>
                    </tool-tip>
                    <spiel-berichte-print-menu class="d-inline-block" :spielId="item.id"
                                                type="waiting">
                    </spiel-berichte-print-menu>
                    <v-btn v-if="item.infos.stream"
                           @click="openStream(item.infos.stream)" icon class="d-inline-block">
                        <v-icon :color="item.vereine.heim.indexOf('pending') !== -1?'blue':''">
                            mdi-video-box</v-icon>
                    </v-btn>
                </div>
            </template>
            <template v-slot:item.ts="{ item }">
                <countdown :startDate="item.infos.datum+'T'+item.infos.uhrzeit"
                           :duration-hours="getDurationHoursFromFrist(item)"
                           class="warning--text font-weight-bold"></countdown>
            </template>
            <template v-slot:no-data>
                <td class="text-left font-weight-bold primary--text">
                    Du hast alle Spielberichte bestätigt!
                </td>
            </template>
        </v-data-table>
        <spiel-bericht-edit-confirm v-if="$route.query.action==='confirmErgebnis'"
                                    :currentData="spielSelected" action="confirmErgebnis">
        </spiel-bericht-edit-confirm>
    </v-card>
</template>

<script>
    import SpielService from "../../../services/data/spielService";
    import {Spiel} from "../../../services/data/spiel";
    import SpielBerichtePrintMenu from "./spielBerichtePrintMenu";
    import SpielBerichtEditConfirm from "./edit/spielBerichtEditConfirm";
    import Countdown from "../../../components/elements/countdown";
    import TabTeamsWithIcons from "../components/tabTeamsWithIcons";
    //import TimeStamp from "../../../services/timeStamp";
    import ToolTip from "../../../components/elements/toolTip";

    export default {
        components: {
            ToolTip,
            TabTeamsWithIcons,
            Countdown,
            SpielBerichtEditConfirm, SpielBerichtePrintMenu},
        name: "spiel-berichte-offen-waiting",
        computed: {
            user(){ return this.$store.state.user; },
            spieleRaw(){ return this.$store.state.realtime.spieleWaiting; },
            vereinNr(){return this.user.permissions.spielbericht},
            path(){ return this.$route.path},
        },
        data: () => ({
            search: '',
            headers: [],
            spiele: [],
            spielSelected: null,
        }),
        created(){
            this.init()
        },
        methods: {
            init(){
                this.bindSpiele();
                this.headers = SpielService.getTableHeader(this.$vuetify,
                    [ {text: 'noch', value: 'ts', sortable: true } ] );
                this.setSpiele();
            },
            quickSearch(content){
                this.search = this.search === content ? '' : content;
            },
            bindSpiele(){
                if ( !this.spieleRaw && this.vereinNr ) {
                    console.log ("bindSpiele WAITING !!!" );
                    this.$store.dispatch('bindRealtimeList', {
                        collection: 'spiele',
                        queryField: 'vereine.gast',
                        queryOperator: '==',
                        queryValue: this.vereinNr + '_waiting',
                        storeField: 'spieleWaiting',
                    });
                }
            },
            getDurationHoursFromFrist(spiel){
                const fristen = SpielService.getFristen(spiel.saison.id);
                return fristen.gast;
            },
            async setSpiele(){
                if ( this.spieleRaw  ) {
                    this.spiele = await SpielService.setSpieleList(this.spieleRaw)
                }
            },
        // confirm spiel content
            openConfirm(spiel, action){
                this.spielSelected = new Spiel();
                this.spielSelected.setFromDataObject(spiel);
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = action;
                this.$router.push({path: p, query: q});
            },
        // open live stream
            openStream(url){
                window.open(url, '_blank').focus();
            }
            /*async setAutoConfirmed(item){
                let spiel = new Spiel();
                spiel.setFromDataObject(item);
                console.log ("setConfirmedOffen", spiel);
                spiel.local.documentUpdates = {
                    ['vereine.heim']: spiel.heim.vereinsNr + '_confirmed',
                    ['vereine.gast']: spiel.gast.vereinsNr + '_confirmed',
                    ['vereine.alle']: [ spiel.heim.vereinsNr ,
                        spiel.gast.vereinsNr ],
                    ['vereine.confirmedGast']: TimeStamp.getGMTTimestamp(),
                    ['vereine.autoConfirmed']: true,
                };
                let reply = await spiel.saveEdited('spiel_edit');
                if ( !reply.successful ) {
                    console.error(spiel.getDBErrorText(reply.content)) ;
                }
            }*/
        },
        watch: {
            spieleRaw: {
                handler(){
                    this.setSpiele();
                },
                deep: true
            },
            vereinNr(){
                this.bindSpiele();
            },
            path(){
                this.init()
            }
        }
    }
</script>

<style scoped>

</style>